import { getCurrentDate } from "@helper/useDateFormat";
import { NoSSR } from "@sphtech/web2-core/components";

type FooterCopyrightProps = {
  testId?: string;
  className: string;
};

export function FooterCopyright({ className, testId }: FooterCopyrightProps) {
  const year = getCurrentDate("yyyy");

  return (
    <div
      data-testid={`${testId}-copyright`}
      className={`${className} text-xxs text-white-200 font-regular`}
    >
      <p className="p-0">
        MDDI (P) 015/06/2025, MDDI (P) 014/06/2025 SPH Digital News Copyright ©{" "}
        <NoSSR>
          <span>{year}</span>
        </NoSSR>{" "}
        . SPH Media Limited. Co. Regn. No. 202120748H
      </p>
    </div>
  );
}
